import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect }from 'react-redux';

import Centered from '../Components/Centered';

import styled from 'styled-components';
import { setGiftAmount, setGiftRecipient, setGiftSender, setTemplate, setNote } from '../Actions'

const StyledFooter = styled.div`
  
`;


const DarkSection = styled.div`
  background-color: #1D2C3C;
  flex-direction: column;
  align-items: flex-start;
  font-weight: 500;
    
  @media (max-width: 600px) {
  } 
  @media (max-width: 480px) {
  }
`;

const Divider = styled.div`
  border-top: 1px solid #ebebeb;
  opacity: 0.271;
  width: 100%;
`;

const FooterLink = styled(Link)`
  margin-left: 0.5em;
  margin-right: 0.5em;
`;

class Footer extends Component {
  prepopulateFields() {
    this.props.dispatch(setGiftAmount({giftAmount: 0.00015}));

    this.props.dispatch(setGiftRecipient({recipientEmail: 'recipient@biterica.com'}));

    this.props.dispatch(setGiftSender ({senderEmail: 'sender@biterica.com'}));

    this.props.dispatch(setTemplate ({template: 'Welcome_to_Bitcoin'}));

    this.props.dispatch(setNote ({note: 'Raz,\r\nHappy Birthday!!\r\n-Raz'}));

    this.props.history.push('/verify');
  }
  render() {
    const debug = process.env.REACT_APP_DEBUG_MODE === 'true';
    return (
      <StyledFooter>

        <DarkSection>
          <Centered>
            <div className="spacer-40px"/>
          </Centered>
          <div className="spacer-20px"/>
          <Centered>
          </Centered>
          <div className="spacer-20px"/>
          <div className="spacer-20px"/>

          <div className="spacer-40px"/>
        </DarkSection>
      </StyledFooter>
    );
  }
}

export default connect()(withRouter(Footer));



// WEBPACK FOOTER //
// ./src/Containers/Footer.js